import React from 'react';
import { useHistory, Link as RouterLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button, TextField, Container, Breadcrumbs, Typography, Divider, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { login, updateFormEmail, updateFormPassword } from '../../actions/login';
import { useTranslation } from 'react-i18next';
import useUser from '../../user/useUser';
import * as constants from '../../constants';

const Login = () => {
    const { t, i18n } = useTranslation();
    const { setUser } = useUser();
    const loading = useSelector(state => state.global.loading);
    const formData = useSelector(state => state.login.formData);
    const generalErrorText = useSelector(state => state.login.generalErrorText);
    const history = useHistory();
    const dispatch = useDispatch();
    const language = i18n.languages[0];
    const location = window.location;
    let query = new URLSearchParams(location.search);
    const email = query.get("userId");
    if (email && !formData.email)
       dispatch(updateFormEmail(email));
    return (
        <Container>

            <Breadcrumbs style={{ marginTop: 20 }}>
                <Typography color="textPrimary">{t("LogIn")}</Typography>
            </Breadcrumbs>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            {generalErrorText ? <Alert style={{ marginTop: 10 }} severity="error">{generalErrorText}</Alert> : null}

            <form noValidate={true}>
                <div style={{ marginTop: 10, maxWidth: 300 }}>
                    <TextField
                        disabled={loading}
                        fullWidth
                        type="email"
                        error={!!formData.emailErrorText}
                        label={t("EMail")}
                        helperText={formData.emailErrorText}
                        value={formData.email}
                        onChange={event => dispatch(updateFormEmail(event.target.value, t))} />
                </div>
                <div style={{ marginTop: 10, maxWidth: 300 }}>
                    <TextField
                        disabled={loading}
                        fullWidth
                        error={!!formData.passwordErrorText}
                        type="password"
                        label={t("Password")}
                        helperText={formData.passwordErrorText}
                        value={formData.password}
                        onChange={event => dispatch(updateFormPassword(event.target.value, t))} />
                </div>

                <div style={{ marginTop: 10 }}>
                    <Button type="submit" variant="contained" color="primary" disabled={loading || !formData.isValid} onClick={() =>
                        dispatch(login(formData.email, formData.password, history, setUser, location, t, language))}>{t("LogIn")}</Button>
                </div>

                <div style={{ marginTop: 20 }}>
                    <Button variant="text" color="primary" disabled={loading} component={RouterLink} to={constants.ROUTE_ACCOUNT_FORGOT_PASSWORD}>{t("ForgotPassword")}</Button>
                </div>
                <div style={{ marginTop: 10 }}>
                    <Button style={{ fontWeight: 'bold', fontSize: '20px' }} variant="text" color="primary"  disabled={loading} component={RouterLink} to={constants.ROUTE_ACCOUNT_REGISTER}>{t("Register")}</Button>
                </div>
            </form>
        </Container>
    );
}

export default Login;